import request from '@/utils/request'
// 登录
export const codeLogin = (loginName, password) => {
	return request.post('/client/login', {
		loginName,
		password
	})
}
